"use client";

import { useEffect, useRef, useLayoutEffect } from 'react';

const USB_INTER_CHAR_MS = 80;
const USB_MIN_LENGTH = 4;

export function useUsbScanner(
  onScan: (code: string) => void,
  opts: { enabled: boolean }
): void {
  const onScanRef = useRef(onScan);
  useLayoutEffect(() => { onScanRef.current = onScan; });

  const buffer = useRef('');
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!opts.enabled) return;

    function handleKey(e: KeyboardEvent) {
      if (timer.current) clearTimeout(timer.current);
      if (e.key === 'Enter') {
        const val = buffer.current.trim();
        buffer.current = '';
        if (val.length >= USB_MIN_LENGTH) onScanRef.current(val);
        return;
      }
      if (e.key.length === 1) {
        const tag = (document.activeElement as HTMLElement)?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') { buffer.current = ''; return; }
        buffer.current += e.key;
        timer.current = setTimeout(() => { buffer.current = ''; }, USB_INTER_CHAR_MS);
      }
    }

    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
      buffer.current = '';
    };
  }, [opts.enabled]);
}
